export default __webpack_public_path__ + "3cfb56a8d2bc9143076bcaeba6c90a70.png";